<script setup lang="tsx">
import type { CustomCells, HybridlyRow } from '@/components/table/Table';
import { IndexStudentActionsTabNavCounts } from '@/components/students/studentActions/IndexStudentActionsTabNav.vue';

import { useHybridlyTable } from '@/hooks/useHybridlyTable';
import { useTableRowClick } from '@/hooks/useTableRowClick';

import { AppliedFilters } from '@/components/distiller/types';

import EmptyState from '@/components/emptyState/EmptyState.vue';
import IndexStudentActionsTabNav from '@/components/students/studentActions/IndexStudentActionsTabNav.vue';
import ShowStudentPageLayout from '@/components/students/ShowStudentPageLayout.vue';
import ShowStudentPageTableLayout from '@/components/students/ShowStudentPageTableLayout.vue';
import TableBadgesCell from '@/components/table/TableBadgesCell.vue';
import TableDateTimeCell from '@/components/table/TableDateTimeCell.vue';
import TableEnumCell from '@/components/table/TableEnumCell.vue';
import TableRequestDataAttributesCell from '@/components/table/TableRequestDataAttributesCell.vue';

type DataRequestRow = HybridlyRow<App.Students.Data.StudentScholarshipData>;

const props = defineProps<{
  appliedFilters: AppliedFilters;
  counts: IndexStudentActionsTabNavCounts;
  distiller: App.Search.Data.DistillerData;
  dataRequests: Table<App.Students.Data.StudentScholarshipData>;
  student: App.Students.Data.StudentData;
}>();

const { table } = useHybridlyTable<App.Students.Data.StudentScholarshipData>(props, 'dataRequests');
const { handleRowClick } = useTableRowClick();

const customCells = {
  type: ({ row, column }) => (
    <TableBadgesCell badgesToDisplay={1} items={[row.value(column.key)?.label]} />
  ),
  requestable_type: ({ row, column }) => <TableEnumCell enumData={row.value(column.key)} />,
  created_at: ({ row, column }) => <TableDateTimeCell date={row.value(column.key)} />,
  attributes: ({ row, column }) => (
    <TableRequestDataAttributesCell attributes={row.value(column.key)} />
  )
} as CustomCells<App.DataRequests.Data.DataRequestData>;

function handleDataRequestRowClick(event: MouseEvent, row: DataRequestRow) {
  const requestableType = row.value('requestable_type') as App.Base.Data.EnumData;
  const type = requestableType.value as string;

  let url = '' as string;
  switch (type) {
    case 'application':
      url = route('data-requests.college-application.edit', { dataRequest: row.key });
      break;
    case 'financial_aid':
      url = route('data-requests.financial-aid.edit', { dataRequest: row.key });
      break;
    case 'test':
      url = route('data-requests.test.edit', { dataRequest: row.key });
      break;
    case 'student_scholarship':
      url = route('data-requests.scholarship.edit', { dataRequest: row.key });
      break;
    default:
      return;
  }

  handleRowClick(url, event);
}
</script>


					<script lang="tsx">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <ShowStudentPageLayout :student :title="student.name">
    <template #tabs>
      <IndexStudentActionsTabNav :student :counts />
    </template>
    <template #table>
      <ShowStudentPageTableLayout
        title="Pending Data Requests"
        :appliedFilters
        :distiller
        :table="table"
        :customCells
        clickableRows
        @clickRow="($event, row) => handleDataRequestRowClick($event, row as DataRequestRow)"
      >
        <template #emptyState>
          <EmptyState
            title="No pending data requests found"
            description="Pending data requests will appear here when this student has requested a data change."
          />
        </template>
      </ShowStudentPageTableLayout>
    </template>
  </ShowStudentPageLayout>
</template>
